<template>
    <CCard>
        <CCardBody>
            <h5 class="text-primary">Preferred Location</h5>
            <GPie v-if="preferredLocationChartData.length" :data="preferredLocationChartData" :keys="keys"/>
        </CCardBody>
    </CCard>
</template>
<script>
import GPie from "@/components/reusable/Charts/GPie.vue";
import clinicalData from "@/containers/ClinicalPlacementDashboard/clinicalData.json";
export default {
    name: "PreferredLocationChart",
    components: {
        GPie,
    },
    computed: {
        preferredLocationChartData() {
            const count = clinicalData.reduce((acc, item) => {
                if (!acc[item["Preferred Location"]] ) {
                    acc[item["Preferred Location"]] = 0;
                }
                acc[item["Preferred Location"]]++;
                return acc;
            }, {});
            const counts = Object.entries(count).map(([preferredLocation, count], index) => ({
                name: preferredLocation,
                value: count,
                backgroundColor: "#b1a5d6",
                borderColor: "#b1a5d6",
            }));
            return counts;
        },
        keys() {
            return ["Preferred Location", "Count"];
        },
    }
};
</script>
